import BasicRouterView from "../../../components/BasicRouterView.vue";

const treinamentoRoutes = {
  path: "tre",
  redirect: { name: "treinamento-criar-listar" },
  meta: {
    label: "Treinamento",
    icon: "engineering",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "treinamento/criar-listar",
      name: "treinamento-criar-listar",
      meta: {
        label: "Criar/Listar Treinamentos",
        icon: "text_snippet",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/CriarListarTreinamentos.vue"
        ),
    },
    {
      path: "treinamento/status",
      name: "treinamento-status",
      meta: {
        label: "Status Treinamento",
        icon: "trending_up",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/StatusTreinamento.vue"),
    },
    {
      path: "treinamento/criar-capacitacao",
      name: "treinamento-criar-capacitacoes",
      meta: {
        label: "Criar Capacitações",
        icon: "directions_run",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/TreinamentoAplicado.vue"),
    },
    {
      path: "treinamento/listar-capacitacao",
      name: "treinamento-listar-capacitacoes",
      meta: {
        label: "Listar Capacitações",
        icon: "list_alt",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/ListarFinalizarCapacitacoes.vue"
        ),
    },
    {
      path: "treinamento/capacitacao-detalhe/:capacitacaoId",
      name: "treinamento-detalhe-capacitacao",
      meta: {
        label: "Detalhe Capacitação",
        icon: "list_alt",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/DetalheCapacitacao.vue"),
    },
    {
      path: "treinamento/criar-treinamento-planilha",
      name: "treinamento-criar-treinamento-planilha",
      meta: {
        label: "Upload Arquivo",
        icon: "file_upload",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/UploadArquivo.vue"),
    },
    {
      path: "treinamento/detalhar-treinamento-pessoa/:treinamentoId",
      name: "treinamento-detalhar-pessoas",
      meta: {
        label: "Upload Arquivo",
        icon: "file_upload",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/DetalharTreinamento.vue"),
    },
    {
      path: "treinamento/detalhar-treinamento-grupo/:treinamentoId",
      name: "treinamento-detalhar-grupos",
      meta: {
        label: "Upload Arquivo",
        icon: "file_upload",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/DetalharTreinamento.vue"),
    },
    {
      path: "treinamento/agendamento",
      name: "treinamento-agendamento",
      meta: {
        label: "Agendamento",
        icon: "event_available",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/Agendamento.vue"),
    },
    {
      path: "treinamento/detalhe-agendamento/:agendamentoUuid",
      name: "treinamento-detalhe-agendamento",
      meta: {
        label: "Agendamento",
        icon: "event_available",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/DetalheAgendamento.vue"),
    },
    {
      path: "treinamento/configurar-certificado/:treinamentoId",
      name: "treinamento-configurar-certificado",
      meta: {
        label: "Configurar Certificado",
        icon: "directions_run",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/ConfigurarCertificado.vue"
        ),
    },
    {
      path: "treinamento/imprimir-certificado-alterado/:funcionarioId/:capacitacaoId",
      name: "treinamento-imprimir-certificado-alterado",
      meta: {
        label: "Configurar Certificado",
        icon: "directions_run",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/ImprimirCertificadoAlterado.vue"
        ),
    },
    {
      path: "treinamento/imprimir-certificado/:funcionarioId/:capacitacaoId",
      name: "treinamento-imprimir-certificado",
      meta: {
        label: "Configurar Certificado",
        icon: "directions_run",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/ImprimirCertificado.vue"),
    },
    {
      path: "treinamento/status-consolidado",
      name: "treinamento-status-consolidado",
      meta: {
        label: "Status Consolidado",
        icon: "timeline",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/StatusTreinamentoConsolidado.vue"
        ),
    },
    {
      path: "treinamento/impressao-presenca/:dados",
      name: "treinamento-presenca-imprimir",
      meta: {
        label: "Status Consolidado",
        icon: "timeline",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/ImprimirListaPresenca.vue"
        ),
    },
  ],
};

export default treinamentoRoutes;
